import createAxiosInstance from '../createAxiosInstance';

const SETTING_API_URL = import.meta.env.VITE_API_URL_PRODUCT;

if (SETTING_API_URL === undefined) {
    throw new Error('Setting API URL is not defined');
}

const axios = createAxiosInstance(SETTING_API_URL);

export default axios;
